let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6XCf4"), load("5pvpJ"), load("1qlDN"), load("1yVM6"), load("5HTv6")]).then(() => parcelRequire('f4NfX'));